module.exports = __webpack_public_path__ + "static/media/education-object-2-1-2.8406ec4f.png";